// libs
import styled, { css } from 'styled-components'
// themes
import { colors } from 'themes/index'
// icons
import DragIconOrigin from '@mui/icons-material/DragHandle'
import EditIconOrigin from '@mui/icons-material/Edit'
import TrashIconOrigin from '@mui/icons-material/Delete'
// utils
import { darken, size } from 'polished'

export const Header = styled('div')`
  align-items: center;
  background: ${colors.darkBlue500};
  color: ${colors.white100};
  display: flex;
  flex: 0 0 64px;
  font-size: 22px;
  font-weight: bold;
  justify-content: space-between;
  padding: 0 24px;
  position: relative;
`

export const Container = styled('form')`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  padding: 16px;
`

export const ButtonsWrapper = styled('div')`
  display: flex;
  gap: 8px;
  margin-top: auto;
  padding-top: 24px;
`

export const AddButton = styled('div')<{ $disabled?: boolean }>`
  && {
    color: ${colors.blue500};
    cursor: pointer;
    display: inline-block;
    font-size: 16px;
    font-weight: 500;
    margin-top: 8px;

    ${({ $disabled }) =>
      $disabled &&
      css`
        pointer-events: none;
        color: ${colors.gray280};
      `};

    &:hover {
      color: ${({ $disabled }) => darken(0.1, $disabled ? colors.gray280 : colors.blue500)};
    }
  }
`

export const FormButtonsWrapper = styled('div')`
  display: flex;
  justify-content: flex-end;

  div:first-child {
    margin-right: 8px;
  }
`

export const ColumnActions = styled('div')`
  background-color: ${colors.white100};
  border-radius: 25px;
  border: 1px solid ${colors.blue500};
  display: flex;
  height: 24px;
  justify-content: space-around;
  min-width: 38px !important;
  padding: 0 2px;
  position: absolute;
  right: 6px;
  top: -8px;
  width: fit-content;
  z-index: 1;

  > div:not(:last-child) {
    border-right: 1px solid ${colors.blue500};
  }

  > div {
    padding: 0 2px;
  }
`

export const ColumnActionButton = styled('div')`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex: 1;
  justify-content: center;

  &:hover {
    svg {
      path {
        fill: ${darken(0.1, colors.blue500)};
      }
    }
  }
`

export const ColumnContent = styled('div')`
  align-items: center;
  background-color: ${colors.gray190};
  border-radius: 4px;
  display: flex;
  flex: 0.6;
  height: 50px;
  overflow: hidden;
  padding: 8px;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

export const ColumnWrapper = styled('div')<{ isDisabled?: boolean }>`
  border-radius: 4px;
  border: 2px solid transparent;
  display: flex;
  height: 54px;
  position: relative;

  &:hover {
    border-color: ${({ isDisabled }) => (isDisabled ? 'transparent' : colors.blue500)};

    ${ColumnActions} {
      display: ${({ isDisabled }) => (isDisabled ? 'none' : 'flex')};
    }
  }

  > div:first-child {
    flex: 1;
  }

  ${ColumnActions} {
    display: none;
  }
`

export const DraggableWrapper = styled('div')`
  margin-bottom: 8px;
`

export const IconWrapper = styled('div')`
  align-items: center;
  border-radius: 4px 0 0 4px;
  display: flex;
  height: inherit;
  margin-right: 8px;
`

export const DragIcon = styled(DragIconOrigin)`
  width: 24px;
`

export const EditIcon = styled(EditIconOrigin)`
  margin: 0 !important;
  ${size('16px')};

  path {
    fill: ${colors.blue500};
  }
`

export const TrashIcon = styled(TrashIconOrigin)`
  margin: 0 !important;
  ${size('16px')};

  path {
    fill: ${colors.blue500};
  }
`
